import { render, staticRenderFns } from "./SlotSettings.vue?vue&type=template&id=362991a5&scoped=true"
import script from "./SlotSettings.vue?vue&type=script&lang=js"
export * from "./SlotSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362991a5",
  null
  
)

export default component.exports